import { LocalStorageService } from './../../local-storage.service';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-finished',
  templateUrl: './finished.component.html',
  styleUrls: ['./finished.component.scss'],
})
export class FinishedComponent implements OnInit {

  constructor( private router: Router, private localStorageService: LocalStorageService) { }

  ngOnInit() {}

  nextButtonHandler(){
    this.localStorageService.set('isFinishedCheck', true);
    this.router.navigate(['/questionnaire/result']);
  }

}
